//Purpose: Create a service module that uses fetch API to send HTTP requests to backend.

import axios from 'axios';
import { useSelector } from 'react-redux';

import { BASE_API_URL } from '../constants/routes';

function useFetchWrapper() {
    const { token } = useSelector((state) => state.auth);

    return {
        get: request('GET'),
        post: request('POST'),
        put: request('PUT'),
        delete: request('DELETE')
    };

    function request(method) {
        return (url, body) => {
            const requestOptions = {
                url: url,
                method: method,
                headers: authHeader(url)
            };
            if (body) {
                requestOptions.headers['Content-Type'] = 'application/json';
                requestOptions.data = body;
            }
            return axios.request(requestOptions).catch((err) => {
                console.log(err);
                throw err;
            });
        };
    }

    //helper functions
    function authHeader(url) {
        const user = JSON.parse(localStorage.getItem('user'));
        const isLoggedIn = !!token;
        const isApiUrl = url.startsWith(BASE_API_URL);
        if (isLoggedIn && isApiUrl) {
            const validToken = user ? token: null;
            return {
                'x-access-Token': `${token}`,
                Accept: 'application/json',
                Authorization: 'Bearer ' + validToken
            };
        } else {
            return {};
        }
    }
}
export default useFetchWrapper;
